module.exports = __webpack_public_path__ + "img/n2.301d704d.jpg";